export default __webpack_public_path__ + "media/images/features/ambassador/profiles/goose_bumps_san-7d0171d2c2bcdff156703812b7ffacbb.jpg";